import { gql } from "graphql-tag";

export const memberBanner = gql`
  fragment Become_a_member_member_banner on Become_a_memberBodyMember_banner {
    type
    primary {
      title
      description
      button_label
      button_section_id
      image
    }
    fields {
      banner_icon
      banner_icon_text
      banner_icon_text_color
      section_id
    }
  }
`;
